<template>
  <el-container>
    
    <el-main>
      <el-form ref="dataForm" :model="dataForm" :rules="rules" label-width="110px" class="demo-ruleForm t_center"
               align="left">
        <el-form-item label="机构：" prop="orgCode" class="cls-col" v-if="orgType == 1">
          <el-select  placeholder="" size="small" placeholder="机构" v-model="dataForm.orgCode" style="margin-right: 10px;" @change="changeOrgCode">
            <el-option v-for="o in org" :label="o.organizationName" :value="o.orgCode"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="选择范围：" prop="scopeType" class="cls-col" size="small">
          <el-radio v-model="dataForm.scopeType" :label="0">所有院校</el-radio><br>
          <el-radio v-model="dataForm.scopeType" :label="1">
            <el-select v-model="scope" allow-create filterable placeholder="请选择院校" @change="confirmScope"
            >
              <el-option
                  v-for="item in scopeListData"
                  :key="item"
                  :label="item"
                  :value="item">
              </el-option>
            </el-select>
          </el-radio>
          <el-tag
              :key="tag.schoolName"
              v-for="tag in dataForm.scopeList"
              closable
              :disable-transitions="false"
              style="margin-left: 5px"
              @close="handleScopeTagClose(tag)">
            {{tag.schoolName}}
          </el-tag>
        </el-form-item>
        <el-form-item label="福利课程：" prop="courseList" class="cls-col">
              <el-button
                  type="success"
                  icon="el-icon-circle-plus-outline"
                  size="small"
                  round
                  @click="addCourse"
                  class="but-cls"
              >选择课程
              </el-button>
              <el-tag
                  :key="tag.courseId"
                  v-for="tag in choseCourses"
                  closable
                  :disable-transitions="false"
                  style="margin-left: 5px"
                  @close="handleTagClose(tag)">
                {{tag.courseName}}
              </el-tag>
        </el-form-item>
        <el-form-item label="宣传图片：" prop="pictureUrl" class="cls-col">
          <el-upload
              v-model="dataForm.pictureUrl"
              :action="uploadURL"
              list-type="picture-card"
              :on-preview="handlePictureCardPreview"
              :on-remove="pictureHandleRemove"
              :on-change="pictureOnChange"
              :on-success="pictureHandleSuccess"
              :before-upload="pictureBeforeAvatarUpload"
              :limit="2"
              :file-list="pictureFileList"
              :show-file-list="true"
          >
            <i class="el-icon-plus"></i>
          </el-upload>
        </el-form-item>
        <el-form-item label="有效日期：" prop="startTime" class="cls-col">
          <el-date-picker
              v-model="dataForm.startTime"
              type="datetime"
              value-format="yyyy-MM-dd HH:mm:ss"
              placeholder="开始日期"
              size="small"
          >
          </el-date-picker>
          -
          <el-date-picker
              arrow-control
              v-model="dataForm.endTime"
              type="datetime"
              value-format="yyyy-MM-dd HH:mm:ss"
              placeholder="结束日期"
              size="small"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item align="center">
          <el-button type="primary" style="float: left" @click="save">保存</el-button>
        </el-form-item>
      </el-form>
    </el-main>
    <el-dialog
        title="选择课程"
        :visible.sync="choseCourse"
        :close-on-click-modal=false
    >
    
      <el-form ref="searchDate" :model="searchData" label-width="80px" label-position="top" style="margin-bottom: 10px">
        <el-row >
  
          <el-col :span="5" class="cls-col">
            <el-form-item label="所属分类" prop="selectedOption">
              <el-cascader
                  expand-trigger="hover"
                  size="small"
                  clearable
                  :options="courseOptions"
                  v-model="searchData.selectedOption"
                  style="width: 100%"
                  :props="{ value: 'courseTypeId', label: 'courseTypeName',children: 'childNodeLst'}"
              >
              </el-cascader>
            </el-form-item>
          </el-col>
          <el-col :span="5" class="cls-col">
            <el-form-item label="课程名称" prop="name">
              <el-input v-model="searchData.name" placeholder="课程名称" size="small" ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="5" class="cls-col">
            <el-form-item style="margin-top: 30px">
              <el-button type="primary" plain size="small" icon="el-icon-search" @click="searchCourse()">查询</el-button>
            </el-form-item>
          </el-col>
        </el-row>
    
      </el-form>
    
      <el-table
          :data="courseData"
          ref="commodityList"
          @select="handleSelectionChange"
          @select-all="handleSelectAll"
          :row-key="getRowKeys"
          border>
        <el-table-column
            type="selection"
            :reserve-selection="true"
            width="55">
        </el-table-column>
        <el-table-column
            prop="name"
            label="课程名称">
        </el-table-column>
        <el-table-column
            prop="orgName"
            label="机构"
        >
        </el-table-column>
        <el-table-column
            prop="ccName"
            label="课程分类"
            :formatter="f_categoryName"
        >
        </el-table-column>
      </el-table>
      <el-pagination
          background
          layout="prev, pager, next"
          :total="total"
          :page-size="pageSize"
          :current-page.sync="currentPage"
          @current-change="handleCurrentChange"
          style="margin-top: 5px; float: right; margin-right: 10px">
      </el-pagination>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="selectCommodity()">确 定</el-button>
      </div>
    </el-dialog>
  </el-container>
</template>

<script>
  import {dateFormat,monthFormat} from '@/api/utils.js'
  export default {
    name: 'addWelfare',
    data() {
      return {
        dataForm: {
          scopeType: 0,
          scopeList: [],
          courseList: [],
          startTime: '',
          endTime: '',
          pictureUrl: '',
          orgCode: '',
        },
        rules: {},
        uploadURL: '',
        pictureFileList: [],
        scopeListData: [],
        total: 0,
        pageSize: 10,
        currentPage: 1,
        choseCourse: false,
        courseData: [],
        courseOptions: [],
        choseCourses: [],
        org: [],
        orgType: '',
        searchData: {
          limit: 0,
          page: 1,
          name: '',
          ccId: '',
          categoryOne: '',
          categoryThree: '',
          categoryTwo: '',
          selectedOption: [],
          commodityStatus: '',
          lessonType: '',
          pccId: '',
          courseType: '0',
          status: 2,
          orgCode: ''
        },
        scope: '',
        courseListTemp: [],
        rules: {
          scopeType:[
            { required: true, message: '请选择福利范围', trigger: 'change' },
          ],
          courseList: [
            { required: true, message: '请选择福利课程', trigger: 'blur' },
          ],
          pictureUrl: [
            { required: true, message: '请上传宣传图片', trigger: 'blur' },
          ],
          startTime: [
            { required: true, message: '请选择有效日期', trigger: 'blur' },
          ],
          orgCode: [
            { required: true, message: '请选择机构', trigger: 'change' },
          ],
        },
      };
    },
    methods: {
      getRowKeys(row) {
        return row.courseId;
      },
      handleScopeTagClose(scope) {
        this.dataForm.scopeList.splice(this.dataForm.scopeList.indexOf(scope), 1);
      },
      confirmScope(val) {
        this.dataForm.scopeType = 1;
        let scope = {
          "schoolName": val
        }
        let flag = true;
        if(this.dataForm.scopeList==null) {
          this.dataForm.scopeList = [];
        }
        for(let selectScope of this.dataForm.scopeList) {
          if(val == selectScope.schoolName) {
            flag = false;
          }
        }
        if(flag) {
          this.dataForm.scopeList.push(scope);
        }
      },
      handleClose() {
        this.choseCourse = false;
      },
      save() {
        
        if(this.dataForm.scopeType == 1 && (this.dataForm.scopeList==null || this.dataForm.scopeList.length == 0)) {
          this.$message({
            type: 'info',
            message: '请选择福利范围！'
          });
          return;
        }
        if(this.orgType == 1 && !this.dataForm.orgCode) {
          this.$message({
            type: 'info',
            message: '请选择机构！'
          });
          return;
        }
        if(this.choseCourses.length == 0) {
          this.$message({
            type: 'info',
            message: '请选择福利课程！'
          });
          return;
        }
        if(!this.dataForm.pictureUrl) {
          this.$message({
            type: 'info',
            message: '请上传宣传图片！'
          });
          return;
        }
        if(!this.dataForm.startTime || !this.dataForm.endTime) {
          this.$message({
            type: 'info',
            message: '请选择有效日期！'
          });
          return;
        }
        this.dataForm.courseList = [];
        for(let course of this.choseCourses) {
          let c = {
            courseId: course.courseId
          }
          this.dataForm.courseList.push(c);
        }
        console.log(this.dataForm);
        
        let params = this.dataForm;
        let url = "/mallWelfare/addWelfare";
        if(this.dataForm.mallWelfareId) {
          url = "/mallWelfare/updateWelfare";
        }
        this.https.fetchPost(url, params, 'json').then((data) => {
          let code = data.data.code;
          let msg = data.data.msg;
          if (code == 200) {
            this.$router.push({
              name: "welfare",
            })
          } else {
            this.$message({
              type: 'info',
              message: '加载失败:' + msg
            });
          }
        }).catch((err) => {
          this.$message.error('网络错误');
        });
      },
      addCourse() {
        this.courseListTemp = JSON.parse(JSON.stringify(this.choseCourses));
        this.searchCourse();
        this.choseCourse = true;
      },
      handleCurrentChange(val) {
        this.searchCourse(val);
      },
      handlePictureCardPreview(file) {
        // this.dialogImageUrl = file.url;
        // this.dialogVisible = true;
      },
      pictureHandleRemove(file, fileList) {
        //this.hidePictureUpload = fileList.length >= this.pictureLimitCount;
      },
      pictureOnChange(file, fileList) {
        //this.hidePictureUpload = fileList.length >= this.pictureLimitCount;
      },
      pictureHandleSuccess(response, file, fileList) {
        this.pictureFileList = [];
        if(response.code == 200) {
          this.dataForm.pictureUrl = response.data.filePath;
          let file = {
            name: response.data.filePath,
            url: response.data.filePath
          };
          this.pictureFileList.push(file);
        } else {
          this.$message.error('上传图片失败!');
        }

      },
      
      pictureBeforeAvatarUpload(file) {
        const isJPG = file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'image/bmp';
        // const isLt2M = file.size / 1024 / 1024 < 20;
        if (!isJPG) {
          this.$message.error('上传图片只能是 JPG/PNG/BMP 格式!');
        }
        // if (!isLt2M) {
        //   this.$message.error('上传图片大小不能超过 2MB!');
        // }
        // const isSize = new Promise(function(resolve, reject) {
        //   let width = 750;
        //   let height = 388;
        //   let _URL = window.URL || window.webkitURL;
        //   let img = new Image();
        //   img.onload = function() {
        //     let valid = img.width/img.height == 16/9;
        //     valid ? resolve() : reject();
        //   };
        //   img.src = _URL.createObjectURL(file);
        // }).then(() => {
        //   return file;
        // }, () => {
        //   this.$message.error('上传图片尺寸必须为16:9!');
        //   return Promise.reject();
        // });
        return isJPG;
      },
      selectScope() {
        this.scopeListData = [];
        let params = {
          scopeType: 1,
          orgCode: this.dataForm.orgCode
        };
        this.https.fetchPost('/mallWelfare/getScopeList', params, 'json').then((data) => {
          let code = data.data.code;
          let msg = data.data.msg;
          if (code == 200) {
            this.scopeListData = data.data.data;
          } else {
            this.$message({
              type: 'info',
              message: '加载失败:' + msg
            });
          }
        }).catch((err) => {
          this.$message.error('网络错误');
        });
      },
      selectCommodity() {
        this.choseCourses = JSON.parse(JSON.stringify(this.courseListTemp));
        this.choseCourse = false;
      },
      searchCourse(val) {
        if(this.searchData.selectedOption.length > 0) {
          this.searchData.ccId = this.searchData.selectedOption[this.searchData.selectedOption.length-1];
        } else {
          this.searchData.ccId = '';
        }
        if(val) {
          this.searchData.page = val;
        } else {
          this.searchData.page = 1;
          this.currentPage = 1;
        }
        this.searchData.limit = 10;
        this.searchData.orgCode = this.dataForm.orgCode
        let params = this.searchData;
        let selectedCourseType = this.searchData.selectedOption;
        params.categoryOne = '';
        params.categoryTwo = '';
        params.categoryThree = '';
        if (selectedCourseType && selectedCourseType.length > 0) {


          switch (selectedCourseType.length) {
            case 1:
              params.categoryOne = selectedCourseType[selectedCourseType.length - 1];
              break;
            case 2:
              params.categoryTwo = selectedCourseType[selectedCourseType.length - 1];
              break;
            case 3:
              params.categoryThree = selectedCourseType[selectedCourseType.length - 1];
              break;
          }
        }
        
        this.https.fetchPost('/course/getCourseByType',params, 'json' ).then((data) => {
          let code = data.data.code;
          let msg = data.data.msg;
          if(code == 200) {
            this.courseData = [];
            if(data.data.data) {
              this.courseData = data.data.data;
              this.$refs.commodityList.clearSelection();
              let courses = [];
              for(let course  of this.courseData) {
                for(let c of this.courseListTemp) {
                  if(course.courseId == c.courseId) {
                    courses.push(course);
                  }
                }
              }
              courses.forEach(row => {
                this.$refs.commodityList.toggleRowSelection(row);
              });
            }
            this.total = data.data.total;
          } else {
            this.$message({
              type: 'info',
              message: msg
            });
          }

        }).catch(err=>{
              console.log(err);
            }
        );
      },
      searchCourseType() {
        let params = {
          orgCode: this.dataForm.orgCode
        };
        this.https.fetchPost('/courseType/courseTypeOfCourseCheck', params, 'json').then((data) => {
          let code = data.data.code;
          let msg = data.data.msg;
          if (code == 200) {
            this.courseOptions = [];
            if(data.data.data.childNodeLst) {
              this.courseOptions = data.data.data.childNodeLst;
            }
          } else {
            this.$message({
              type: 'info',
              message: '加载失败:' + msg
            });
          }

        }).catch(err => {
              console.log(err);
              this.$message.error('网络错误');
            }
        );
      },
      f_categoryName(row, column, cellValue, index) {
        let categoryName = '';
        if(row.categoryOneName) {
          categoryName += row.categoryOneName;
        }
        if(row.categoryTowName) {
          categoryName += '/'+row.categoryTowName;
        }
        if(row.categoryThreeName) {
          categoryName += '/'+row.categoryThreeName;
        }
        return categoryName;
      },
      changeOrgCode() {
        this.selectScope();
        this.dataForm.scopeList = [];
        this.scope = "";
        this.searchCourseType(this.dataForm.orgCode);
        this.choseCourses = [];
        this.courseListTemp = [];
      },
      selectOrg() {
        this.https.fetchGet('/managerOrganization/getOrganizationList', '', 'from').then((data) => {
          let code = data.data.code;
          let msg = data.data.msg;
          if (code == 200) {
            this.org = data.data.data;
          } else {
            this.$message({
              type: 'info',
              message: msg
            });
          }

        }).catch(err => {
              console.log(err);
              this.$message.error('网络错误');
            }
        );
      },

      handleSelectAll(selection) {
        
        if(selection.length == 0) {
          for(let course of this.courseData) {
            let flag = false;
            let unChose = {};
            for(let choseCourse of this.courseListTemp) {
              if(course.courseId == choseCourse.courseId) {
                flag = true;
                unChose = choseCourse;
              }
            }
            if(flag) {
              let index = this.courseListTemp.indexOf(unChose);
              this.courseListTemp.splice(index,1);
            }
          }
        } else {
          for(let course of selection) {
            let flag = false;
            let unChose = {};
            for(let choseCourse of this.courseListTemp) {
              if(course.courseId == choseCourse.courseId) {
                flag = true;
                unChose = choseCourse;
              }
            }
            if(!flag) {
              let c = {
                courseId: course.courseId,
                courseName: course.name
              };
              this.courseListTemp.push(c);
            }
          }
        }
      },
      
      handleSelectionChange(courses,row) {

        // if(this.courseListTemp.length > 9) {
        //   this.$message({
        //     type: 'info',
        //     message: "最多选择10个课程！"
        //   });
        //   this.$refs.commodityList.toggleRowSelection(row,false);
        //   return;
        // }

        let flag = false;
        let unChose = {};
        for(let choseCourse of this.courseListTemp) {
          if(row.courseId == choseCourse.courseId) {
            flag = true;
            unChose = choseCourse;
          }
        }
        if(flag) {
          let index = this.courseListTemp.indexOf(unChose);
          this.courseListTemp.splice(index,1);
        } else {
          let course = {
            courseId: row.courseId,
            courseName: row.name
          };
          this.courseListTemp.push(course);
        }
        
      },
      handleTagClose(tag,tags) {
        this.choseCourses.splice(this.choseCourses.indexOf(tag), 1);
      },
      searchWelfare(welfareId) {
        let params = {
          mallWelfareId: welfareId
        };
        this.https.fetchPost('/mallWelfare/getWelfare', params, 'json').then((data) => {
          let code = data.data.code;
          let msg = data.data.msg;
          if (code == 200) {
            let dataForm = data.data.data
            dataForm.startTime = dateFormat(dataForm.startTime)
            dataForm.endTime = dateFormat(dataForm.endTime)
            this.choseCourses = JSON.parse(JSON.stringify(dataForm.courseList));
            let picture = {
              name: "fuli.jpg",
              url: dataForm.pictureUrl
            };
            this.pictureFileList.push(picture);
            this.dataForm = dataForm;
          } else {
            this.$message({
              type: 'info',
              message: '加载失败:' + msg
            });
          }

        }).catch(err => {
              console.log(err);
              this.$message.error('网络错误');
            }
        );
      },
    },
    watch: {
      'scope': function(newVal,oldVal) {
        if(this.scopeListData.indexOf(newVal) < 0 ) {
          this.scopeListData.push(newVal);
        }
      }
    },
    created: function() {
      this.orgType = this.$store.state.orgType;
      this.dataForm.orgCode = this.$store.state.orgCode
      this.searchCourseType(this.dataForm.orgCode);
      this.selectOrg();
      this.selectScope();
      let welfareId = this.$route.query.welfareId;
      if(welfareId) {
        this.searchWelfare(welfareId);
      }
      this.uploadURL = this.https.baseURL + '/file/fdfs_upload';
    }
  };
</script>

<style scoped>

</style>
